import { render } from "./createEvent.vue?vue&type=template&id=040cc1e8"
import script from "./createEvent.vue?vue&type=script&lang=js"
export * from "./createEvent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__